// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/engagement/v2/link_templates" endpoint
 */
import { isEngagementV2LinkTemplatesResult } from "@dashboardApi/apis/engagementV2LinkTemplates/validators";

import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementV2LinkTemplates } from "./constants";
import type { EngagementV2LinkTemplatesParams, EngagementV2LinkTemplatesResult } from "./types";

export const getDataTableEngagementV2LinkTemplates = reactQueryTableFetcherAdapter(
  engagementV2LinkTemplates,
  (
    signal: AbortSignal,
    { appGroupId, query, groupby, limit = 10, start = 0, sortdir, sortby }: EngagementV2LinkTemplatesParams
  ): Promise<EngagementV2LinkTemplatesResult> => {
    return fetch(
      "/engagement/v2/link_templates",
      "GET",
      {
        groupby,
        limit,
        sortby,
        sortdir,
        start,
        app_group_id: appGroupId,
        query: serializeQueryObjects(query),
      },
      { signal }
    );
  },
  isEngagementV2LinkTemplatesResult
);
